export default "__VITE_ASSET__d12c5a44__"